module.exports = __webpack_public_path__ + "img/icon-send.5d437a0f.svg";